import { render, staticRenderFns } from "./UserInviteUpload.vue?vue&type=template&id=ef5d809a&scoped=true"
import script from "./UserInviteUpload.vue?vue&type=script&lang=js"
export * from "./UserInviteUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef5d809a",
  null
  
)

export default component.exports